'use client';

import React, { useState } from 'react';
import { Link } from '@/components/link';

import { Drawer } from '@/components/drawer';
import SocialLinks, { type SocialLinksProps } from '@/components/social-links';
import DrawerNavLinks, { type DrawerNavLinksProps } from './components/drawer-nav-links';
import { Button } from '@/components/ui/button';
import Icon from '@/components/icons';

type NavigationProps = {
  primaryNavProps: DrawerNavLinksProps;
  secondaryNavProps?: DrawerNavLinksProps;
  socialLinksProps?: SocialLinksProps;
};

const Navigation = ({
  primaryNavProps,
  secondaryNavProps = { links: [] },
  socialLinksProps = { socialIcons: [], tagline: '' },
}: NavigationProps) => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const { links: primaryNavLinks } = primaryNavProps;

  return (
    <>
      <div className="order-1 lg:hidden">
        <Button
          size="sm"
          variant="ghost"
          aria-label="open mobile navigation"
          onClick={() => setIsMobileNavOpen(true)}
          className="[&_svg]:size-5 cursor-pointer"
        >
          <Icon name="hamburger" aria-hidden />
        </Button>
        <Drawer
          anchor="left"
          ariaLabel="Mobile navigation"
          ariaLabelledBy="mobile-navigation-drawer-title"
          closeAriaLabel="Close navigation"
          isOpen={isMobileNavOpen}
          onClose={() => setIsMobileNavOpen(false)}
        >
          <DrawerNavLinks {...primaryNavProps} />
          <div className="mt-12">
            {secondaryNavProps && <DrawerNavLinks {...secondaryNavProps} isPrimary={false} />}
          </div>
          {socialLinksProps && <SocialLinks {...socialLinksProps} className="my-7" />}
        </Drawer>
      </div>
      <nav className="order-2 hidden flex-1 lg:flex lg:justify-end">
        <ul className="flex items-center gap-2">
          {primaryNavLinks.map((link) => (
            <li key={link.title}>
              <Link
                href={link.url}
                className="px-6 py-2 font-bold text-lg hover:text-primary-500"
                tracking={{
                  event: 'navigation_click',
                  navigation_type: 'main_nav',
                  click_text: link.title,
                  nav_level: '1',
                }}
              >
                {link.title}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
};

export default Navigation;
